import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {HeadTitle} from '@shared';
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(HeadTitle, {
      title: "Privacy Policy"
    }), "\n", _jsx(_components.h1, {
      children: "Privacy Policy"
    }), "\n", _jsxs(_components.p, {
      children: ["At ", _jsx("a", {
        href: "/",
        children: "CNA Classes For Me"
      }), ", one of our main priorities is the privacy\nof our visitors. This Privacy Policy document contains types of information that\nis collected and recorded by CNA Classes For Me and how we use it."]
    }), "\n", _jsx(_components.h2, {
      children: "Summary"
    }), "\n", _jsx(_components.p, {
      children: "Here are key points from the present document. You will find more information on\neach point below."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "We do not process personal sensitive information."
      }), "\n", _jsx(_components.li, {
        children: "We do not receive any of your information from third parties."
      }), "\n", _jsx(_components.li, {
        children: "We process your information to provide, improve, and administer our services."
      }), "\n", _jsx(_components.li, {
        children: "You can request to delete your data by visiting\nhttps://cnaclassesforme.com/profile."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Log Files"
    }), "\n", _jsx(_components.p, {
      children: "CNA Classes For Me follows a standard procedure of using log files. These files\nlog visitors when they visit websites. All hosting companies do this and a part\nof hosting services' analytics. The information collected by log files include\ninternet protocol (IP) addresses, browser type, Internet Service Provider (ISP),\ndate and time stamp, referring/exit pages, and possibly the number of clicks.\nThese are not linked to any information that is personally identifiable. The\npurpose of the information is for analyzing trends, administering the site,\ntracking users' movement on the website, and gathering demographic information."
    }), "\n", _jsx(_components.h2, {
      children: "Cookies and Web Beacons"
    }), "\n", _jsx(_components.p, {
      children: "Like any other website, CNA Classes For Me uses \"cookies\". These cookies are\nused to store information including visitors' preferences, and the pages on the\nwebsite that the visitor accessed or visited. The information is used to\noptimize the users' experience by customizing our web page content based on\nvisitors' browser type and/or other information."
    }), "\n", _jsx(_components.h2, {
      children: "Deleting Your Data"
    }), "\n", _jsxs(_components.p, {
      children: ["Your data is tied to your member profile and will be kept for as long as you\nmaintain an account on ", _jsx("a", {
        href: "/",
        children: "CNA Classes For Me"
      }), ". You may at any time\ndelete your profile and associated data by visiting the member page at\nhttps://cnaclassesforme.com/profile."]
    }), "\n", _jsx(_components.h2, {
      children: "Children's Information"
    }), "\n", _jsx(_components.p, {
      children: "Another part of our priority is adding protection for children while using the\ninternet. We encourage parents and guardians to observe, participate in, and/or\nmonitor and guide their online activity."
    }), "\n", _jsx(_components.p, {
      children: "CNA Classes For Me does not knowingly collect any Personal Identifiable\nInformation from children under the age of 13."
    }), "\n", _jsx(_components.h2, {
      children: "Consent"
    }), "\n", _jsx(_components.p, {
      children: "By using our website, you hereby consent to our Privacy Policy and agree to its\nTerms and Conditions."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
